import { render, staticRenderFns } from "./FormBonusPointSettings.vue?vue&type=template&id=62a86472&scoped=true&"
import script from "./FormBonusPointSettings.vue?vue&type=script&lang=js&"
export * from "./FormBonusPointSettings.vue?vue&type=script&lang=js&"
import style0 from "./FormBonusPointSettings.vue?vue&type=style&index=0&id=62a86472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a86472",
  null
  
)

export default component.exports